import React from 'react';
import './Machinesdpserie.css';
import clampstr from '../../../imgs/clampstruct.webp';
import clampst from '../../../imgs/clampstruct1.webp';


const Machinesdpserie = () => {
    return (
        <div className="Machinesd-container">
            <div className='Plasticcompa'>
                <h2 className="Machinesd-title">Disha Servo Two-platen Injection Molding Machines–DP Series:</h2>

                <div className="Machinesd-content">
                    <ul className="Machinesd-text">
                        <li>The special screw with a large aspect ratio is adopted to improve the plasticizing capacity.</li>
                        <li>Ultra-wide space of the mold clamping area, large core pulling space and easy operation.</li>
                        <li>The clamping movable template adopts a linear guide rail, low lubrication cost & simple maintenance.</li>
                    </ul>
                </div>
                <div className="Machinesp">
                    <img src={clampstr} alt="72 Cavity PET Preforms Machine" className="Machinesdp-image" />
                    <img src={clampst} alt="72 Cavity PET Preforms Machine" className="Machinesdp-image" />

                </div>
            </div>
        </div>
    );
};

export default Machinesdpserie;
